import { useGetGenericUiConfig } from "~/modules/dtwin/composables/useGetGenericUiConfig";
import type { DynamicUI } from "~/modules/dtwin/models/DynamicUI.interface";
import { mergeUIConfig } from "~/modules/dtwin/utils/mergeUIConfig";

const { getGenericUiConfig } = useGetGenericUiConfig();

export function getMergedOrGenericUIConfig(
  modelUIConfig?: DynamicUI,
): DynamicUI | undefined {
  let mergedUIConfig: DynamicUI | undefined = modelUIConfig;

  const genericUIConfig = getGenericUiConfig();

  if (mergedUIConfig?.list?.columns?.length) {
    mergedUIConfig!.list.columns = mergeUIConfig(
      genericUIConfig.list.columns,
      mergedUIConfig?.list?.columns,
    );
  } else if (mergedUIConfig?.list) {
    mergedUIConfig.list.columns = genericUIConfig.list.columns;
  } else if (mergedUIConfig) {
    mergedUIConfig.list = { columns: genericUIConfig.list.columns };
  } else {
    mergedUIConfig = genericUIConfig;
  }

  // remove hidden columns
  if (mergedUIConfig) {
    mergedUIConfig.list.columns = mergedUIConfig.list.columns.filter(
      (column) => !column.hide,
    );
  }

  // merge details
  mergeDetailKey("description", genericUIConfig, mergedUIConfig);
  mergeDetailKey("additionalMetadata", genericUIConfig, mergedUIConfig);
  mergeDetailKey("configuration", genericUIConfig, mergedUIConfig);
  mergeDetailKey("firmware", genericUIConfig, mergedUIConfig);
  mergeDetailKey("certificate", genericUIConfig, mergedUIConfig);

  return mergedUIConfig;
}

function mergeDetailKey(
  key:
    | "description"
    | "additionalMetadata"
    | "configuration"
    | "firmware"
    | "certificate",
  genericUIConfig: DynamicUI,
  mergedUIConfig?: DynamicUI,
) {
  if (mergedUIConfig?.details) {
    if (mergedUIConfig?.details[key]) {
      if (
        Array.isArray(genericUIConfig.details[key]) &&
        Array.isArray(mergedUIConfig?.details[key])
      ) {
        mergedUIConfig.details[key] = mergeUIConfig(
          genericUIConfig.details[key],
          mergedUIConfig?.details[key],
        );

        // remove hidden fields
        mergedUIConfig.details[key] = mergedUIConfig.details[key].filter(
          (field) => !field.hide,
        );
      }
    } else if (genericUIConfig.details[key]) {
      mergedUIConfig.details[key] = genericUIConfig.details[key];
    }
  }
}
